
module Meevo.Components.CommonClasses {
    "use strict";
    import SettingsDto = Meevo.Model.SettingsDto;
    import RevertData = Meevo.Model.RevertData;
    import EffectiveLevelFlag = Meevo.Model.EffectiveLevelFlag;

    export abstract class SettingsSectionBase extends Meevo.Components.CommonClasses.CommonSectionBase {
        protected businessTypeDetail: Model.BusinessTypeDetail = {};

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService = null,
            protected modalService: Meevo.Components.Modal.IModalService,
            sectionSecurityKey?: string,
            protected contextParams?: Meevo.ContextParamsService,
            isInteropContext = false,
        ) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, noun, identityService, sectionSecurityKey)
            this.isInteropContext = isInteropContext;
        }

        activate(): void {
            super.activate();
        }

        getMyLevel(): EffectiveLevelFlag {
            let locationLevel = EffectiveLevelFlag.Location;

            let btdIsTenant = Model.Guard.isSomething(this.businessTypeDetail) &&
                (this.businessTypeDetail.id === '00000000-0000-0000-0000-000000000001' || this.businessTypeDetail.id == null);

            if (this.identityService.inCentralOfficeMode())
                locationLevel = btdIsTenant ? EffectiveLevelFlag.Tenant : EffectiveLevelFlag.BusinessType;

            return locationLevel;
        }

        //Update the My level based on the setting's settability to handle single location tenant when settings are not settable at location level
        updateMyLevel(settingSettableLevels: number, myLevel: number) {

            if (this.identityService.current().isSingleLocation
                && EffectiveLevelFlag.SingleLocation !== settingSettableLevels
                && (settingSettableLevels & EffectiveLevelFlag.SingleLocation) ===
                EffectiveLevelFlag.SingleLocation
                && (settingSettableLevels & EffectiveLevelFlag.Location) !== EffectiveLevelFlag.Location) {
                if (settingSettableLevels % 2 !== 0)
                    myLevel = EffectiveLevelFlag.Tenant;
                else
                    myLevel = EffectiveLevelFlag.BusinessType;
            }

            return myLevel;
        }




        canEditField(fieldName: string, settingModel: SettingsDto): boolean {
            if (this.mode === Meevo.Model.MaintenanceFormState.Readonly)
                return false;

            let setting = _.find(settingModel.settings, setting => setting.displayName.toUpperCase() === fieldName.toUpperCase());

            if (Model.Guard.isNothing(setting) || setting.settableLevels === 0) return false;

            let myLevel = this.getMyLevel();
            let myLevelEffective = myLevel;

            myLevelEffective = this.updateMyLevel(setting.settableLevels, myLevel);

            if (this.identityService.current().isSingleLocation) {
                myLevel = EffectiveLevelFlag.SingleLocation;
            }

            //if i am a single location tenant and the setting can only be set at tenat level, business type level and single location level then assume I am the lowest level this setting can be edited at.


            let sl: EffectiveLevelFlag = (setting.settableLevels & myLevel);

            if (sl !== myLevel)
                return false;

            //Check if offoverride is set
            if (Model.Guard.isSomething(setting.metadata)
                && setting.metadata.calculationRule === Meevo.Model.OverrideRuleEnum.OffOverride
                && setting.metadata.effectiveLevel < myLevelEffective
                && setting.effectiveValue.trim() === "0"
                && setting.metadata.effectiveLevel > 0) {
                return (myLevelEffective <= setting.metadata.effectiveLevel);
            }

            return true;
        }

        getRevertToValue(settingMatadata: Model.SettingMetadata, settableLevels: any): RevertData {
            let returnVal: Model.RevertData = { effectiveLevel: 0, revertToValue: '0' };
            let myLevel = this.getMyLevel();

            myLevel = this.updateMyLevel(settableLevels, myLevel);
            // update the myLevel in case of 9,11,10 type of settings for a single location tenant.

            if (myLevel > EffectiveLevelFlag.BusinessType && Model.Guard.isSomething(settingMatadata.businessTypeValue)) {
                returnVal.effectiveLevel = EffectiveLevelFlag.BusinessType;
                returnVal.revertToValue = settingMatadata.businessTypeValue;
                return returnVal;
            }
            if (myLevel > EffectiveLevelFlag.Tenant && Model.Guard.isSomething(settingMatadata.tenantValue)) {
                returnVal.effectiveLevel = EffectiveLevelFlag.Tenant;
                returnVal.revertToValue = settingMatadata.tenantValue;
                return returnVal;
            }
            if (myLevel > EffectiveLevelFlag.System) {
                returnVal.effectiveLevel = EffectiveLevelFlag.System;
                returnVal.revertToValue = settingMatadata.systemValue;
                return returnVal;
            }

            return null;

        }

        isOverriden(setting: string, settingCollection: string, myVal: any): boolean {
            const thisSetting = this.getThisSetting(setting, settingCollection)
            const hasMetadata = Model.Guard.isSomething(thisSetting) && _.has(thisSetting, 'metadata')
            const settingMetadata = hasMetadata ? thisSetting['metadata'] : null
            if (Model.Guard.isNothing(settingMetadata))
                return false
            /*  System=0 , Tenant=1 , BusinessType=2 , Location=4   */
            const effectiveLevel = angular.copy(settingMetadata['effectiveLevel']);
            let effectiveValue: string = Model.Guard.isSomething(thisSetting['effectiveValue']) ? thisSetting['effectiveValue'] : '';

            let myLevel = this.getMyLevel();
            myLevel = this.updateMyLevel(thisSetting.settableLevels, myLevel);

            if (typeof (myVal) == "boolean")
                myVal = myVal ? 1 : 0;
                                
            if (thisSetting.id === 2000 || thisSetting.id === 2001) {
                //  Customize for Column and Time Zoom  * TODO: Change UI to use MeevoPercentageField
                //  myVal = myVal / 100;
            }
            


            if (myLevel == +effectiveLevel || "" + myVal != effectiveValue.trim())
                return true;

            return false;

        }

        showRevertIndicator(setting: string, settingCollection: string, myVal: any): boolean {

            if (!this.hasSettings(setting, settingCollection)) {
                return false;
            }
            const myModel = this.model[settingCollection] || this.model;
            let canShow = this.canEditField(setting, myModel);
            let canChange = this.isOverriden(setting, settingCollection, myVal);

            return canShow && canChange;
        }

        revertToParent(setting: string, settingCollection: string): void {

            const myModel = this.model[settingCollection] || this.model;
            let thisSetting = this.getThisSetting(setting, settingCollection);
            let metadata: Model.SettingMetadata = thisSetting['metadata'];
            const revertToData = this.getRevertToValue(metadata, thisSetting.settableLevels);

            if (Model.Guard.isNothing(revertToData) && Model.Guard.isNothing(metadata))
                return;

            const type = typeof (myModel[setting]);

            if (type === "number" && revertToData.revertToValue)
                myModel[setting] = + revertToData.revertToValue;
            else if (type === "boolean" && revertToData.revertToValue)
                myModel[setting] = revertToData.revertToValue.trim() === "1" ? true : false;
            else
                myModel[setting] = Model.Guard.isSomething(revertToData.revertToValue) ? revertToData.revertToValue.trim() : null;

            //If not saved already, save the original values before reverting. May be we need it later if not saving the reverted values
            if (Model.Guard.isNothing(metadata['originalEffectiveLevel']))
                metadata['originalEffectiveLevel'] = metadata.effectiveLevel;
            if (Model.Guard.isNothing(thisSetting['originalEffectiveValue']))
                thisSetting['originalEffectiveValue'] = thisSetting['effectiveValue'];

            metadata.effectiveLevel = revertToData.effectiveLevel;
            thisSetting['effectiveValue'] = revertToData.revertToValue;

            if (thisSetting.id === 2000 || thisSetting.id === 2001) { //  Customize for Column and Time Zoom  * TODO: Change UI to use MeevoPercentageField
                myModel[setting] = (+revertToData.revertToValue * 100).toString();
                thisSetting.effectiveValue = (+thisSetting.effectiveValue * 100).toString();
            }
        }

        getThisSetting(setting: string, settingCollection: string): Model.Setting {
            var myModel = this.model;
            var hasCollection = false;
            if (Model.Guard.isSomething(settingCollection) && settingCollection.trim().length >= 1) {
                myModel = this.model[settingCollection];
                hasCollection = true;
            }
            let settings: Model.Setting[] = !hasCollection || this.hasSettings(setting, settingCollection)
                ? myModel['settings']
                : null;
            let settingName = settings ? setting[0].toUpperCase() + setting.substr(1, setting.length - 1) : null;
            let thisSetting: Model.Setting =
                settings && settingName ? _.findWhere(settings, { displayName: settingName }) : null;

            return thisSetting;

        }

        hasSettings(setting: string, settingCollection: string): boolean {
            const modelHasSettingCollection = Model.Guard.isSomething(settingCollection) &&_.has(this.model, settingCollection)
            const modelHasSetting = Model.Guard.isSomething(setting) && _.has(this.model, setting);
            if (!modelHasSetting && !modelHasSettingCollection)
                return false

            const isObject = _.isObject(this.model['settings']) || _.isObject(this.model[settingCollection])
            const settings = this.model['settings'] || !!this.model[settingCollection] && this.model[settingCollection]['settings']
            if (isObject && Model.Guard.isNothing(settings))
                return false

            return true
        }

        preSave(): void {
            super.preSave();
            if (Model.Guard.isNothing(this.model.settings)) {
                for (var prop in this.model) {
                    if (this.model.hasOwnProperty(prop)) {
                        let modelProp = this.model[prop];
                        let originalModelProp = this.originalEntity[prop];
                        this.processRevertedSettings(modelProp, originalModelProp, false)
                    }
                }
            } else {

                this.processRevertedSettings(this.model, this.originalEntity, true)

            }
            this.loadingInProgress = false;
        }

        processRevertedSettings(modelProp: any, originalModelProp: any, handleRevertOnly:any) {

            let myLevel = this.getMyLevel();

            if (Model.Guard.isSomething(modelProp) && Model.Guard.isSomething(modelProp.settings)) {
                let modelSettingCol: Model.Setting[] = modelProp.settings,
                    revertSettingCol: Model.Setting[] = [],
                    newInfoSettings = [];

                for (var setting in modelSettingCol) {
                    let modelSetting = modelSettingCol[setting];
                    let dName = modelSetting.displayName;

                    let sName = dName[0].toLowerCase() + dName.substr(1) || dName;

                    let effectiveMyLevel = this.updateMyLevel(modelSetting.settableLevels, myLevel);

                    if (modelProp[sName] instanceof Date) {
                        modelProp[sName] = modelProp[sName].getTime();
                        originalModelProp[sName] = originalModelProp[sName].getTime();
                    }

                    // Check field value and effective level is same as the model we recieved.
                    // if it is then remove it from the collection so that we don't save data that hasn't been changed.
                    if (!handleRevertOnly && modelProp[sName] === originalModelProp[sName]
                        && Model.Guard.isSomething(modelSetting.metadata)
                        && modelSetting.metadata.effectiveLevel === originalModelProp.settings[setting].metadata.effectiveLevel
                    ) {

                        delete modelProp[sName];

                    }
                    //if the settings value have changed identify if it's an actual change or reversion.
                    else {
                        newInfoSettings.push(modelSettingCol[setting]);

                        if (modelSetting.metadata.effectiveLevel !== effectiveMyLevel && modelSetting.metadata.effectiveLevel !== originalModelProp.settings[setting].metadata.effectiveLevel) {
                            if (modelProp[sName] != modelSetting.effectiveValue)  { // revert was initiated, but reverted value was changed again. disregard revert action and take the new value.
                                modelSetting.metadata.effectiveLevel = modelSetting.metadata['originalEffectiveLevel'] || myLevel;
                                modelSetting['effectiveValue'] = modelSetting['originalEffectiveValue'] || modelProp[sName];
                            } 
                            else { //saving the reverted value. setup the reverted column
                                modelSetting.effectiveValue = null;
                                revertSettingCol.push(modelSetting);
                            }
                        }
                    }
                }
                
                modelProp.reverted = revertSettingCol;
                if(!handleRevertOnly)
                    modelProp.settings = newInfoSettings;
            }

        }

        /* TODO: Modify to recursively get object properties */
        // console.log('isEqual: ', _.isEqual(this.originalEntity, this.model));

        /* SOLUTION Still Needs To Work With Arrays */
        // let test = {};
        // test = this.difference(this.originalEntity, this.model);
        // console.log('deepDiff: ', test);
        difference(original: Object, override: Object): Object {

            var obj = {};
            for (var key in original) {
                if (key in override) {
                    if (_.isObject(override[key]) && !_.isArray(override[key])) {
                        var diff = this.difference(original[key], override[key]);
                        if (!_.isEmpty(diff)) {
                            obj[key] = diff;
                        }
                    } else if (!_.isEqual(original[key], override[key])) {
                        obj[key] = override[key];
                    }
                }
            }
            return obj;
        }


    }
}